import { Component } from '@angular/core';
import { Populations } from '../../utilities/populations';

@Component({
  selector: 'fgb-social-media-links',
  templateUrl: './social-media-links.component.html',
  styleUrl: './social-media-links.component.scss',
})
export class SocialMediaLinksComponent {
  populations = Populations;
}
